export default "__VITE_ASSET__L8gGK_ha__"